<template>
    <div ref="notificationInfo">
        <div v-if="!loading.all">
          <div class="d-flex align-items-center col-md-12">
            <feather-icon
              class="icon-hover mr-2"
              icon="ChevronLeftIcon"
              size="24"
              @click="returnSurveys()"
            />
            <div class="d-flex">
                <h5 class="mb-0" v-if="form.title"><strong>{{ form.title }}</strong></h5>
                <span class="mr-50 ml-50">-</span>
                <span>{{ form.create_date }}</span>
            </div>
            <div class="ml-2">
                <b-badge variant="warning" pill class="custom-badge-graph mr-50">{{ form.total_response }}</b-badge>
                <span>Respuestas</span>
            </div>
          </div> 
          <filter-swapper :trigger="selectedRows.length === 0" id="survey_swapper" :controlHeightButtons="controlHeight">
            <template #slot1>
              <form-render ref="formRender" :key="keyFormRender" class="px-0 ml-4 position-relative" :fields="fields" :form.sync="formFilter"
                containerButtonsClass="col-md-4 mt-2 mb-1 d-flex align-items-center">
                <template #buttons>
                  <b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" @click="cleanFilter" :disabled="loading.charts"><feather-icon icon="RefreshCwIcon"/></b-button>
                </template>
                <template #extra>
                  <div class="container-buttons-excel-graph">
                    <div class="row justify-content-end flex-mobile-bottom">
                        <b-button v-if="false" class="push-right separation-buttons" variant="outline-success" :disabled="loading.excel" @click="downloadExcel()">
                          <feather-icon v-if="!download" icon="DownloadIcon"/>
                          <i v-else :class="['fa', 'fa-spinner', 'fa-spin']"/>
                          {{$t('Exportar excel')}}
                        </b-button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <li class="mt-1">A continuación se muestran las estadísticas de la encuesta.</li>
                  </div>
                </template>  
              </form-render>
            </template>
          </filter-swapper>
          <div class="padding-form-notification col-md-12">
            <charts v-if="!loading.charts" :questions="form.questions"/>
            <div v-else class="center-spinner mb-2">
              <b-spinner />
            </div>
          </div>
        </div>
        <div v-else class="center-spinner mb-2">
          <b-spinner />
        </div>
    </div>
</template>
<script>
import Charts from './Charts.vue'
import { mapGetters } from 'vuex'
export default {
  props: ['data'],
  components: {Charts},
  data () {
    return {
      form: {
        questions: []
      },
      loading: {
        excel: false,
        all: true,
        charts: false,
        survey: false
      },
      download: false,
      selectedCountry: [],
      controlHeight: { class: 'row mb-2 spacing-label-field'},
      selectedRows: [],
      fields: [],
      keyFormRender: 0,
      formFilter: {}
    }
  },
  watch: {
    surveys_graph (value) {
      this.form = value
      this.loading.all = false
      this.loading.charts = false
      this.loading.survey = false
      this.setFieldDisabled('countries', false)
    },
    countries (value) {
      this.setSelectOptions('country', { options: value })
    }
  },
  computed: {
    ...mapGetters({
      surveys_graph: 'getSurveysGraph',
      countries: 'getCountries'
    })
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    returnSurveys () {
      this.$emit('returnSurveys', {list: true, survey: false, resultsGraph: false})
    },
    setInitialData () {
      this.fields = [
        {
          fieldType: 'FieldSelect', 
          name: 'countries', 
          label: 'País', 
          multiple: true, 
          clearable: true, 
          placeholder: 'Todos los países', 
          options: [], 
          containerClass: 'col-sm-5 col-md-5 col-xl-5 pr-0',
          change: this.changeCountry,
          disabled: false 
        }
      ]
      this.setCountries()
      this.getSurveysGraph()
    },
    getSurveysGraph () {
      this.loading.survey = true
      const queryParams = {
        survey_id: this.data.id
      }
      if (this.formFilter.countries && this.formFilter.countries.length > 0) {
        queryParams.country_id = this.formFilter.countries.map(item => item.id)
      }
      const params = {}
      this.$store.dispatch('fetchService', { name: 'getSurveysGraph', queryParams, params})
    },
    setCountries () {
      if (this.countries && !!this.countries.length) {
        this.setSelectOptions('countries', { options: this.countries })
      }
    },
    setSelectOptions (name, { options }) {
      const index = this.getPositionFindIndex(this.fields, 'name', name)
      if (index !== -1) {
        this.fields[index].options = options
        this.keyFormRender++
      }
    },
    getPositionFindIndex (origin, type,  name) {
      return origin.findIndex(el => el[type] === name)
    },
    changeCountry () {
      this.setFieldDisabled('countries', true)
      this.loading.charts = true
      this.getSurveysGraph()
    },
    cleanFilter () {
      this.formFilter = {}
      this.loading.charts = true
      this.getSurveysGraph()
    },
    getFieldByName(name) {
      return this.fields[this.m_getElementIndex(this.fields, 'name', name)]
    },
    setFieldDisabled(name, value) {
      const field = this.getFieldByName(name)
      if (field) field.disabled = value
    }
  }
}
</script>
<style>
.custom-badge-graph{
  background-color: #F4BB43;
  padding-right: 0.8rem;
  padding-left: 0.8rem;
}
.center-spinner {
  display: flex;
  justify-content: center;
}
.container-buttons-excel-graph {
  position: absolute;
  right: 30px;
  top: 30px;
}
</style>